module.exports = __webpack_public_path__ + "img/title_decoration.983f1f98.png";